import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonStandaloneModule } from '../../../../app/shared/common-standalone.module';

@Component({
  selector: 'vi-toolbar',
  standalone: true,
  imports: [CommonStandaloneModule, MatToolbarModule],
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViToolbarComponent {
  colorMap = {
    viorange: 'warn',
    eclipse: 'primary',
    white: 'accent',
    transparent: '',
  };
  @Input() color: 'viorange' | 'eclipse' | 'white' | 'transparent' = 'viorange';

  @Input() shadow = true;

  @Input() height = 64;
}
